export { menus, menus as mainMenu } from './menu-data';
export { _mockMenu, DefaultQuotesList } from './components/Header/_mockMenu';
export { NavigationHeader } from './components/Header';
export { NavigationFooter } from './components/NavigationFooter';
export { FooterStickyNav } from './components/NavigationFooter/FooterStickyNav';
export { QuoteBar } from './components/Header/QuoteBar';
export { TopBar } from './components/TopBar';
export { CornerstoneNavigation, showCornerStone } from './components/CornerstoneNavigation';
export { socialSites } from './components/NavigationFooter/footerEntity';
export type { CornerstoneNavigationProps } from './components/CornerstoneNavigation';
export type { SocialSites } from './components/NavigationFooter/footerEntity';
export { handleMenuItemsClickEvent } from './utils';

export { FusionHeader } from './components/FusionHeader';
export type { FusionHeaderProps } from './components/FusionHeader';

export { QuoteBox } from './components/QuoteBox';

export type {
  NavigationHeaderProps,
  NavigationMenus,
  FooterVariant,
  GlobalMenu,
  HeaderVariant,
  MenuInterface,
} from './entities';
export type { FooterLink } from './components/NavigationFooter/footerEntity';

export type { FooterNavigationGroup } from './components/NavigationFooter/footerEntity';
